import { useLocation } from "react-router";

import { useRouteResponse } from "./useRouteResponse";

export enum ThemeEnum {
  light = "light",
  dark = "dark",
}

/**
 * @description return ThemeEnum.dark when current page is video page or video article page, otherwise return ThemeEnum.light
 */
export function useTheme() {
  const { article } = useRouteResponse("articlePage");
  const pathname = useLocation().pathname;

  const isVideoArticle = article?.displayType == "video";
  const isVideoPage = pathname == "/tags/video";
  const theme =
    isVideoArticle || isVideoPage ? ThemeEnum.dark : ThemeEnum.light;

  return theme;
}
